import client from './ApiClient';

function getTags(query) {
  return client(`v2/tags`, { method: 'GET', params: query });
}

export { getTags };
